module.exports = __webpack_public_path__ + "static/media/332.5ffe39d7.png";